module.exports = __webpack_public_path__ + "assets/img/signup-image.153d213b.png";